import React, { ReactElement, useEffect } from "react"
import { useTranslation } from "react-i18next"
import wrongNetworkIcon from "../assets/icons/wrong-network.svg"
import Text from "./Text"
import { useIsMobile } from "src/hooks/useIsMobile"
import { Box } from "@mui/material"
import Button from "./Button"
import Modal from "./Modal"
import { useSelector } from "react-redux"
import { AppState } from "src/state"
import { hasSwitchFunction, switchNetwork } from "src/utils/connectors"
import { useWeb3React } from "@web3-react/core"
import { getChainId } from "src/utils"

interface Props {
  onClose: () => void
}

export default function WrongNetworkModal({ onClose }: Props): ReactElement {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const connectedWallet = useSelector(
    (state: AppState) => state.user.connectedWallet,
  )
  const { chainId } = useWeb3React()

  useEffect(() => {
    if (chainId === getChainId()) {
      onClose()
    }
  }, [chainId, onClose])

  return (
    <Modal open onClose={onClose} title="">
      <Box textAlign="center" mt={1}>
        <img src={wrongNetworkIcon} width={isMobile ? 48 : 96} />
        <Text variant="h4">{t("Wrong Network")}</Text>
        <Text mt={1} mb={2}>
          {t("Please connect to the appropriate network")}
        </Text>
        {connectedWallet && hasSwitchFunction(connectedWallet) && (
          <Button onClick={switchNetwork} fullWidth>
            {t("Switch Network")}
          </Button>
        )}
      </Box>
    </Modal>
  )
}
